// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"621":"d1fcc6d8","743":"3dcc9f53","917":"3cd4948e"}[chunkId] + ".chunk.js";
};